import { AppPropsWithLayout } from '../types/layoutExtensions';
import { Navigation } from '../components/Navigation';

import '../styles/index.scss';
import '@athenamortgages/athena-navigation/styles.css';
import '@athenamortgages/component-library/styles.css';
import '@athenamortgages/grid/styles.css';
import { Page } from '../components/Page';

function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  const getLayout = Component.getLayout ?? ((page: any) => page);
  return getLayout(
    <Page>
      <Navigation />
      <Component {...pageProps} />
    </Page>,
  );
}

export default MyApp;
